import React from "react";
import { observer } from "mobx-react";
import { SatelliteMachineCreateStore } from "../../store";
import { SatelliteMachineCreateForm } from "./SatelliteMachineCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type SatelliteMachineCreateProps = {
  satelliteMachineCreateStore: SatelliteMachineCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const SatelliteMachineCreate: React.FC<SatelliteMachineCreateProps> =
  observer(
    ({ satelliteMachineCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={satelliteMachineCreateStore.isSaving} />
          <SatelliteMachineCreateForm
            satelliteMachineCreateStore={satelliteMachineCreateStore}
            nameError={satelliteMachineCreateStore.errors.name?.message}
            onNameChange={(value: string) => {
              satelliteMachineCreateStore.setNameValue(value);
            }}
            name={satelliteMachineCreateStore.entityValues.name}
            machineCodeError={
              satelliteMachineCreateStore.errors.machineCode?.message
            }
            onMachineCodeChange={(value: string) => {
              satelliteMachineCreateStore.setMachineCodeValue(value);
            }}
            machineCode={satelliteMachineCreateStore.entityValues.machineCode}
            satelliteTypeError={
              satelliteMachineCreateStore.errors.satelliteType?.message
            }
            onSatelliteTypeChange={(value: string) => {
              satelliteMachineCreateStore.setSatelliteTypeValue(value);
            }}
            satelliteType={
              satelliteMachineCreateStore.entityValues.satelliteType
            }
            regionError={satelliteMachineCreateStore.errors.region?.message}
            onRegionChange={(value: string) => {
              satelliteMachineCreateStore.setRegionValue(value);
            }}
            region={satelliteMachineCreateStore.entityValues.region}
            certificateFingerprintError={
              satelliteMachineCreateStore.errors.certificateFingerprint?.message
            }
            onCertificateFingerprintChange={(value: string) => {
              satelliteMachineCreateStore.setCertificateFingerprintValue(value);
            }}
            certificateFingerprint={
              satelliteMachineCreateStore.entityValues.certificateFingerprint
            }
            certificateExpiresAtError={
              satelliteMachineCreateStore.errors.certificateExpiresAt?.message
            }
            onCertificateExpiresAtChange={(value) => {
              satelliteMachineCreateStore.setCertificateExpiresAtValue(value);
            }}
            certificateExpiresAt={
              satelliteMachineCreateStore.entityValues.certificateExpiresAt
            }
            authTokenHashError={
              satelliteMachineCreateStore.errors.authTokenHash?.message
            }
            onAuthTokenHashChange={(value: string) => {
              satelliteMachineCreateStore.setAuthTokenHashValue(value);
            }}
            authTokenHash={
              satelliteMachineCreateStore.entityValues.authTokenHash
            }
            authTokenLastFourError={
              satelliteMachineCreateStore.errors.authTokenLastFour?.message
            }
            onAuthTokenLastFourChange={(value: string) => {
              satelliteMachineCreateStore.setAuthTokenLastFourValue(value);
            }}
            authTokenLastFour={
              satelliteMachineCreateStore.entityValues.authTokenLastFour
            }
            authTokenCreatedAtError={
              satelliteMachineCreateStore.errors.authTokenCreatedAt?.message
            }
            onAuthTokenCreatedAtChange={(value) => {
              satelliteMachineCreateStore.setAuthTokenCreatedAtValue(value);
            }}
            authTokenCreatedAt={
              satelliteMachineCreateStore.entityValues.authTokenCreatedAt
            }
            authTokenRotatedAtError={
              satelliteMachineCreateStore.errors.authTokenRotatedAt?.message
            }
            onAuthTokenRotatedAtChange={(value) => {
              satelliteMachineCreateStore.setAuthTokenRotatedAtValue(value);
            }}
            authTokenRotatedAt={
              satelliteMachineCreateStore.entityValues.authTokenRotatedAt
            }
            statusError={satelliteMachineCreateStore.errors.status?.message}
            onStatusChange={(value: string) => {
              satelliteMachineCreateStore.setStatusValue(value);
            }}
            status={satelliteMachineCreateStore.entityValues.status}
            authorizedAtError={
              satelliteMachineCreateStore.errors.authorizedAt?.message
            }
            onAuthorizedAtChange={(value) => {
              satelliteMachineCreateStore.setAuthorizedAtValue(value);
            }}
            authorizedAt={satelliteMachineCreateStore.entityValues.authorizedAt}
            authorizedByError={
              satelliteMachineCreateStore.errors.authorizedBy?.message
            }
            onAuthorizedByChange={(value) => {
              satelliteMachineCreateStore.setAuthorizedByValue(value);
            }}
            authorizedBySelectedValue={
              satelliteMachineCreateStore.entityValues.showAuthorizedBy
            }
            onAuthorizedBySelected={(value) => {
              satelliteMachineCreateStore.setSelectedAuthorizedBy(value);
            }}
            authorizedByOptions={satelliteMachineCreateStore.getAuthorizedByOptions()}
            suspendedAtError={
              satelliteMachineCreateStore.errors.suspendedAt?.message
            }
            onSuspendedAtChange={(value) => {
              satelliteMachineCreateStore.setSuspendedAtValue(value);
            }}
            suspendedAt={satelliteMachineCreateStore.entityValues.suspendedAt}
            suspendedByError={
              satelliteMachineCreateStore.errors.suspendedBy?.message
            }
            onSuspendedByChange={(value) => {
              satelliteMachineCreateStore.setSuspendedByValue(value);
            }}
            suspendedBySelectedValue={
              satelliteMachineCreateStore.entityValues.showSuspendedBy
            }
            onSuspendedBySelected={(value) => {
              satelliteMachineCreateStore.setSelectedSuspendedBy(value);
            }}
            suspendedByOptions={satelliteMachineCreateStore.getSuspendedByOptions()}
            suspensionReasonError={
              satelliteMachineCreateStore.errors.suspensionReason?.message
            }
            onSuspensionReasonChange={(value: string) => {
              satelliteMachineCreateStore.setSuspensionReasonValue(value);
            }}
            suspensionReason={
              satelliteMachineCreateStore.entityValues.suspensionReason
            }
            enabledError={satelliteMachineCreateStore.errors.enabled?.message}
            onEnabledChange={(value: boolean) => {
              satelliteMachineCreateStore.setEnabledValue(value);
            }}
            enabled={satelliteMachineCreateStore.entityValues.enabled}
            allowedTenantIdsError={
              satelliteMachineCreateStore.errors.allowedTenantIds?.message
            }
            onAllowedTenantIdsChange={(value: string) => {
              satelliteMachineCreateStore.setAllowedTenantIdsValue(value);
            }}
            allowedTenantIds={
              satelliteMachineCreateStore.entityValues.allowedTenantIds
            }
            proxyEnabledError={
              satelliteMachineCreateStore.errors.proxyEnabled?.message
            }
            onProxyEnabledChange={(value: boolean) => {
              satelliteMachineCreateStore.setProxyEnabledValue(value);
            }}
            proxyEnabled={satelliteMachineCreateStore.entityValues.proxyEnabled}
            proxyPortError={
              satelliteMachineCreateStore.errors.proxyPort?.message
            }
            onProxyPortChange={(value: number | undefined) => {
              satelliteMachineCreateStore.setProxyPortValue(value);
            }}
            proxyPort={satelliteMachineCreateStore.entityValues.proxyPort}
            proxyProtocolsError={
              satelliteMachineCreateStore.errors.proxyProtocols?.message
            }
            onProxyProtocolsChange={(value: string) => {
              satelliteMachineCreateStore.setProxyProtocolsValue(value);
            }}
            proxyProtocols={
              satelliteMachineCreateStore.entityValues.proxyProtocols
            }
            botEnabledError={
              satelliteMachineCreateStore.errors.botEnabled?.message
            }
            onBotEnabledChange={(value: boolean) => {
              satelliteMachineCreateStore.setBotEnabledValue(value);
            }}
            botEnabled={satelliteMachineCreateStore.entityValues.botEnabled}
            botMaxConcurrentError={
              satelliteMachineCreateStore.errors.botMaxConcurrent?.message
            }
            onBotMaxConcurrentChange={(value: number | undefined) => {
              satelliteMachineCreateStore.setBotMaxConcurrentValue(value);
            }}
            botMaxConcurrent={
              satelliteMachineCreateStore.entityValues.botMaxConcurrent
            }
            workerEnabledError={
              satelliteMachineCreateStore.errors.workerEnabled?.message
            }
            onWorkerEnabledChange={(value: boolean) => {
              satelliteMachineCreateStore.setWorkerEnabledValue(value);
            }}
            workerEnabled={
              satelliteMachineCreateStore.entityValues.workerEnabled
            }
            publicIpError={satelliteMachineCreateStore.errors.publicIp?.message}
            onPublicIpChange={(value: string) => {
              satelliteMachineCreateStore.setPublicIpValue(value);
            }}
            publicIp={satelliteMachineCreateStore.entityValues.publicIp}
            locationError={satelliteMachineCreateStore.errors.location?.message}
            onLocationChange={(value: string) => {
              satelliteMachineCreateStore.setLocationValue(value);
            }}
            location={satelliteMachineCreateStore.entityValues.location}
            countryCodeError={
              satelliteMachineCreateStore.errors.countryCode?.message
            }
            onCountryCodeChange={(value: string) => {
              satelliteMachineCreateStore.setCountryCodeValue(value);
            }}
            countryCode={satelliteMachineCreateStore.entityValues.countryCode}
            lastHeartbeatAtError={
              satelliteMachineCreateStore.errors.lastHeartbeatAt?.message
            }
            onLastHeartbeatAtChange={(value) => {
              satelliteMachineCreateStore.setLastHeartbeatAtValue(value);
            }}
            lastHeartbeatAt={
              satelliteMachineCreateStore.entityValues.lastHeartbeatAt
            }
            lastHeartbeatMetricsError={
              satelliteMachineCreateStore.errors.lastHeartbeatMetrics?.message
            }
            onLastHeartbeatMetricsChange={(value: string) => {
              satelliteMachineCreateStore.setLastHeartbeatMetricsValue(value);
            }}
            lastHeartbeatMetrics={
              satelliteMachineCreateStore.entityValues.lastHeartbeatMetrics
            }
            connectedAtError={
              satelliteMachineCreateStore.errors.connectedAt?.message
            }
            onConnectedAtChange={(value) => {
              satelliteMachineCreateStore.setConnectedAtValue(value);
            }}
            connectedAt={satelliteMachineCreateStore.entityValues.connectedAt}
            disconnectedAtError={
              satelliteMachineCreateStore.errors.disconnectedAt?.message
            }
            onDisconnectedAtChange={(value) => {
              satelliteMachineCreateStore.setDisconnectedAtValue(value);
            }}
            disconnectedAt={
              satelliteMachineCreateStore.entityValues.disconnectedAt
            }
            tunnelConnectedAtError={
              satelliteMachineCreateStore.errors.tunnelConnectedAt?.message
            }
            onTunnelConnectedAtChange={(value) => {
              satelliteMachineCreateStore.setTunnelConnectedAtValue(value);
            }}
            tunnelConnectedAt={
              satelliteMachineCreateStore.entityValues.tunnelConnectedAt
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={satelliteMachineCreateStore.isProcessing}
            onSave={() => satelliteMachineCreateStore.saveNewSatelliteMachine()}
            onCancel={() =>
              satelliteMachineCreateStore.cancelNewSatelliteMachine()
            }
          />
          <ErrorDialog
            open={satelliteMachineCreateStore.errorDialogOpened}
            title={satelliteMachineCreateStore.errorTitle}
            description={satelliteMachineCreateStore.errorDescription}
            onClose={() => satelliteMachineCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
